<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Jobs</v-tab>
            <v-tab>Personal Information</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card
                    class="mx-auto"
                    flat
                    :loading="loading"
                    loader-height="10"
                    tile
                >
                    <v-toolbar
                    color="#0c477c"
                    dark
                    flat
                    height="40"
                    >
                        <v-spacer></v-spacer>
                        <v-toolbar-title class="jobs-count" >
                            {{ total + ' Jobs Found.' }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list two-line tile flat class="py-0">
                        <template v-for="(job, index) in jobs">
                            <v-list-item
                            :key="`job-${index}`"
                            :value="job.id"                 
                            >
                                <template>
                                    <v-list-item-content @click.stop="openJob(job.id)">
                                        <v-list-item-title v-if="job.user.name" v-html="`Cleaner: ${job.user.name}`"></v-list-item-title>
                                        <v-list-item-subtitle>{{ job.job_time | moment('MMMM Do YYYY, h:mm a') }}</v-list-item-subtitle>
                                        <div>
                                            <v-chip
                                            class="mr-2 mb-1"
                                            :color="getColor(job.status)"
                                            text-color="white"
                                            small
                                            label
                                            >
                                            {{ job.status | capitalize }}
                                            </v-chip>
                                        </div>
                                    </v-list-item-content>
                                </template>
                            </v-list-item>
                            <v-divider
                            :key="`dv-${index}`"
                            ></v-divider>
                        </template>
                        <v-list-item v-if="pagination.total > 1">
                            <v-list-item-content>
                                <v-pagination
                                    v-model="pagination.current"
                                    :length="pagination.total"
                                    @input="onPageChange"
                                    :total-visible="totalVisible"
                                ></v-pagination>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile class="primary">
                    <v-card-text>
                        <v-form ref="estimatorFields">
                            <v-list flat>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-select
                                            v-model="form.status"
                                            :items="filteredStatuses"
                                            item-text="label"
                                            item-value="value"
                                            label="Select a Status"
                                            @change="submit"
                                        ></v-select>
                                        <v-select
                                            v-model="form.cover_check"
                                            :items="yes_no"
                                            item-text="label"
                                            item-value="value"
                                            label="Cover Check"
                                            @change="submit"
                                        ></v-select>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="admin-action">
                        <v-spacer></v-spacer>
                        <v-btn large text @click="submit" :loading="loading">Update</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> 
                </v-card>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="personalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                                <v-text-field
                                                v-model="form.first_name"
                                                :error-messages="errors"
                                                label="First Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                                <v-text-field
                                                v-model="form.last_name"
                                                :error-messages="errors"
                                                label="Last Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Email" rules="email">
                                                <v-text-field
                                                v-model="form.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <v-text-field
                                                v-model="form.phone"
                                                label="Phone"
                                                required
                                            ></v-text-field>
                                            <v-text-field
                                                v-model="form.phone_2"
                                                label="Phone 2"
                                                required
                                            ></v-text-field>
                                            <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                <v-text-field
                                                v-model="form.street_address"
                                                :error-messages="errors"
                                                label="Street Address"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                <v-text-field
                                                v-model="form.city"
                                                :error-messages="errors"
                                                label="City"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="State" rules="required">
                                                <v-select
                                                    v-model="form.state"
                                                    :items="states"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="Select a State"
                                                    data-vv-name="state"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                <v-text-field
                                                v-model="form.zip"
                                                :error-messages="errors"
                                                label="Zip Code"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <v-text-field
                                                v-model="form.pricing"
                                                label="Pricing"
                                                required
                                            ></v-text-field>
                                            <v-textarea
                                                v-model="form.note"
                                                label="Notes"
                                            ></v-textarea>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>          
                        <v-btn large min-width="50%" color="blue darken-1" text to="/customers">Cancel</v-btn>              
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Update</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_2: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                service: 'Cleaning',
                county: null,
                status: '',
                cover_check: '',
                pricing: '',
                note: ''
            },
            loading: false,
            jobs: [],
            pagination: {
                current: 1,
                total: 0
            },
            total: 0,
            totalVisible: 5,
            filter: {
                customer: "",
            },
            yes_no: [
                {value: 'yes', label: 'Yes'},
                {value: 'no', label: 'No'},
            ]
        }
    },
    created() {
        this.getCustomer()
        this.getJobs()
    },
    computed: {
        ...mapGetters({
            counties: 'data/counties',
            sizes: 'data/sizes',
            options: 'data/options',
            states: 'data/states',
            statuses: 'data/statusArray',
        }),
        filteredStatuses() {
            return this.statuses.filter(status => {
                return status.value == 'active' || status.value == 'archived'
            })
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        ...mapActions({
            updateCustomer: 'data/updateCustomer',
        }),
        getJobs() {
            this.loading = true
            this.drawer = false
            this.$set(this.filter, 'customer', this.id)
            axios.get('admin/customerjobs/all?page=' + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.jobs = response.data.jobs.data
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getJobs()
            this.$vuetify.goTo(0)
        },
        getCustomer() {
            if(this.id) {
                axios.get('admin/customers/get?id=' + this.id)
                    .then((response) => {
                        this.form = response.data

                        if(response.data.schedule !== null)
                            this.form.datetime = new Date(response.data.schedule)

                        this.form.status = response.data.status
                        this.$nextTick()
                    })
            }
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateCustomer(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: '/customers' })
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    //this.tab = 0
                }
            }
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
        openJob(id) {
            this.$router.push({ path: '/job/'+id })
        }
    }
}
</script>

<style lang="sass" scoped>
.admin-action 
    background: #1976d2
    button 
        width: 100%
        background: #ffffff
        color: #1976d2
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.jobs-count 
    font-size: 14px
</style>